import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HelpComponent } from './help/help.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsOfUseComponent } from './terms-of-use/terms-of-use.component';

const routes: Routes = [
    { path: ':clientCode/help-and-support', component: HelpComponent },
    { path: ':clientCode/privacy-policy', component: PrivacyPolicyComponent },
    { path: ':clientCode/terms-of-use', component: TermsOfUseComponent }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class SupportRoutingModule {}
